import { render, staticRenderFns } from "./SendIndicationsInfoPart.vue?vue&type=template&id=643568d6&scoped=true"
import script from "./SendIndicationsInfoPart.vue?vue&type=script&lang=js"
export * from "./SendIndicationsInfoPart.vue?vue&type=script&lang=js"
import style0 from "./SendIndicationsInfoPart.vue?vue&type=style&index=0&id=643568d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643568d6",
  null
  
)

export default component.exports